import { render, staticRenderFns } from "./AdminCreateBlog.vue?vue&type=template&id=ca4a015e&scoped=true&"
import script from "./AdminCreateBlog.vue?vue&type=script&lang=js&"
export * from "./AdminCreateBlog.vue?vue&type=script&lang=js&"
import style0 from "./AdminCreateBlog.vue?vue&type=style&index=0&id=ca4a015e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4a015e",
  null
  
)

export default component.exports